import { render, staticRenderFns } from "./CobranzaUpdate.vue?vue&type=template&id=19bd40fc&scoped=true"
import script from "./CobranzaUpdate.vue?vue&type=script&lang=js"
export * from "./CobranzaUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bd40fc",
  null
  
)

export default component.exports